import React from 'react'
import Nav from '@mc/navigation'
import { CheckoutSteps, LogIn, Logo } from './components'
import { useNavigationSteps } from './useNavigationSteps'

export const NavigationDesktop = () => {
  const {
    context: { theme },
  } = useNavigationSteps()

  return (
    <Nav
      contained={false}
      background={theme === 'gradient' ? 'transparent' : 'solid'}
      dynamicHeight
    >
      <Nav.Left className='flex-1'>
        <Logo />
      </Nav.Left>

      <Nav.Center className='d-flex flex-1 justify-content-center'>
        <CheckoutSteps className='d-flex mc-mx-auto' />
      </Nav.Center>

      <Nav.Right className='flex-1 justify-content-end'>
        <LogIn />
      </Nav.Right>
    </Nav>
  )
}
